export const getStorageItem = (
  storage,
  key,
  fallback = undefined,
  decodeJson = true
) => {
  try {
    const value = storage.getItem(key);
    return value !== null ? (decodeJson ? JSON.parse(value) : value) : fallback;
  } catch {
    return fallback;
  }
};

export const setStorageItem = (storage, key, value, stringify = true) => {
  try {
    return storage.setItem(key, stringify ? JSON.stringify(value) : value);
  } catch {
    return false;
  }
};

export const removeStorageItem = (storage, key) => {
  try {
    storage.removeItem(key);
  } catch {
    return false;
  }
};
